import { SearchFilterTag } from '@/components';
import { fetchGovernmentNumber } from '@/features/government-search/_utils/search-government';
import type { ProjectSearchFormType } from '@/features/search/_models/projects-search';
import type { SharedSearchFormType } from '@/features/search/_models/shared-search';
import { t } from '@/i18n';
import { type FC, useEffect, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

export const PaymentTag: FC<{ onResetPayment: () => void }> = ({
  onResetPayment,
}) => {
  const { control: sharedSearchControl, setValue: setSharedSearchValue } =
    useFormContext<SharedSearchFormType>();
  const { control: projectSearchControl } =
    useFormContext<ProjectSearchFormType>();
  const [corporateName, setCorporateName] = useState<string | undefined>(
    undefined,
  );
  const [isLoading, setIsLoading] = useState(true);
  const [corporateNumber, sheetType] = useWatch({
    control: sharedSearchControl,
    name: ['corporateNumber', 'sheetType'],
  });

  const watchedValues = useWatch({
    control: projectSearchControl,
    name: ['fundSheetType', 'skipAdministrativeReformTeamEvaluation'],
  });

  const [fundSheetType, skipAdministrativeReformTeamEvaluation] =
    watchedValues ?? [];

  useEffect(() => {
    if (corporateNumber) {
      (async () => {
        const res = await fetchGovernmentNumber({ corporateNumber });
        setCorporateName(res.at(0)?.corporateName);
        setIsLoading(false);
      })();
    } else {
      setCorporateName(undefined);
      setIsLoading(false);
    }
  }, [corporateNumber]);

  if (sheetType === 'RS' && skipAdministrativeReformTeamEvaluation === 'true') {
    return null;
  }
  if (sheetType === 'KS' && fundSheetType !== 'standard') {
    return null;
  }

  if (!corporateName || isLoading) {
    return null;
  }

  return (
    <SearchFilterTag
      closable={true}
      label={`${t('payment-name')}: ${corporateName}`}
      onClose={() => {
        setSharedSearchValue('corporateNumber', null);
        onResetPayment();
      }}
    />
  );
};
